export const MEDIA_SIZE = {
  nano: 38,
  tiny: 76,
  micro: 128,
  small: 256,
  medium: 500,
  large: 960,
  supersize: 1500,
  xsupersize: 1920,
  xxsupersize: 2560,
  xxxsupersize: 3840,
} as const;
